import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  jobId: null,
  requirements: {},
  filteredRequirements: {},
  candidates: null,
  jobStatus: null,
  jobMatchingStatus: null,
  areRequirementsSent: false,
  title: "",
  jobSpec: "",
  selectedCVs: [],
  jobs: null,
  alreadyMatchedOnce: false,
  noRequirementsSet: false,
  weights: {
    hard_skills_weight: 0.25,
    soft_skills_weight: 0.25,
    education_weight: 0.25,
    experience_weight: 0.25,
  },
  atsJobPosts: null,
}

const jobSlice = createSlice({
  name: "job",
  initialState: INITIAL_STATE,
  reducers: {
    reset: (state) => {
      state = INITIAL_STATE
    },
    setTitle: (state, action) => {
      state.title = action.payload
      state.jobId = null
    },
    setJobSpec: (state, action) => {
      state.jobSpec = action.payload
      state.jobId = null
    },
    setRequirements: (state, action) => {
      const { requirements, jobId } = action.payload
      state.requirements = requirements
      state.jobId = jobId
      state.candidates = []
      state.areRequirementsSent = false
    },
    setAreRequirementsSend: (state, action) => {
      state.areRequirementsSent = action.payload
    },
    setCandidates: (state, action) => {
      state.candidates = action.payload.candidates
    },
    setJobStatus: (state, action) => {
      state.jobStatus = action.payload
    },
    setJobMatchingStatus: (state, action) => {
      state.jobMatchingStatus = action.payload
    },
    setSelectedCVs: (state, action) => {
      state.selectedCVs = action.payload
    },
    storeJob: (state, action) => {
      const storedJobs = state.jobs ?? {}
      storedJobs[action.payload.id] = action.payload
      storedJobs[action.payload.originalId] = action.payload // Store originalId if it exists
      state.jobs = storedJobs
    },
    storeJobInformation: (state, action) => {
      const storedJobs = state.jobs ?? {}
      const jobId = action.payload.id;

      if (!jobId) return;

      const job = storedJobs[jobId] || {}
      storedJobs[jobId] = {
        ...job,
        ...action.payload.information,
      }
      state.jobs = storedJobs
    },
    storeJobSkill: (state, action) => {
      const storedJobs = state.jobs ?? {}
      const jobId = action.payload.id;
      const skillType = action.payload.skill?.type;

      if (!jobId || !skillType) return;

      const job = storedJobs[jobId] || {}
      storedJobs[jobId] = {
        ...job,
        [skillType]: [
          ...(job[skillType] || []),
          action.payload.skill,
        ],
      }
      state.jobs = storedJobs
    },
    storeJobCreatedAt: (state, action) => {
      const storedJobs = state.jobs ?? {}
      const jobId = action.payload.id;

      if (!jobId) return;

      const job = storedJobs[jobId] || {}
      storedJobs[jobId] = {
        ...job,
        created_at: action.payload.created_at,
      }
      state.jobs = storedJobs
    },
    setJobs: (state, action) => {
      const jobsDic = {}
      action.payload.forEach((job) => {
        jobsDic[job.id] = job
      })
      state.jobs = jobsDic
    },
    setAtsJobPosts: (state, action) => {
      state.atsJobPosts = action.payload
    },
    setAlreadyMatchedOnce: (state, action) => {
      state.alreadyMatchedOnce = action.payload
    },
    setNoRequirementsSet: (state, action) => {
      state.noRequirementsSet = action.payload
    },
    setWeights: (state, action) => {
      const keys = Object.keys(action.payload)
      const obj = {
        ...state.weights,
      }
      keys.forEach((key) => {
        obj[key] = Number(action.payload[key])
      })
      state.weights = obj
    },
    resetJobSlice: (state) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        state[key] = INITIAL_STATE[key]
      })
    },
    resetSelectedJobSlice: (state) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        if (key === "jobs") return;

        state[key] = INITIAL_STATE[key]
      })
    },
    removeJob: (state, action) => {
      const jobId = action.payload;
      if (state.jobs && state.jobs[jobId]) {
        delete state.jobs[jobId];
      }
    },
  },
})

export const {
  reset,
  setTitle,
  setJobSpec,
  setRequirements,
  setCandidates,
  setAreRequirementsSend,
  setSelectedCVs,
  storeJob,
  storeJobInformation,
  storeJobCreatedAt,
  storeJobSkill,
  setJobs,
  setJobStatus,
  setAtsJobPosts,
  resetJobSlice,
  resetSelectedJobSlice,
  setAlreadyMatchedOnce,
  setNoRequirementsSet,
  setJobMatchingStatus,
  setWeights,
  removeJob,
} = jobSlice.actions
export default jobSlice.reducer
